<template>
  <div class="template-modal__body">
    <div class="template-modal__body-inner">
      <label class="template-modal__body-label">
        <input
          id=""
          type="radio"
          name="radio_tex"
          @click="quote()"
        >
        <i class="fa fa-check-circle" />
      </label>

      <div class="template-modal__body-template">
        <div
          class="template-modal__message-body-template-text"
          v-html="body"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { eventBus } from "@/utility/event-bus";

export default {
  props: {
    body: String,
  },
  methods: {
    quote() {
      eventBus.setMessageTemplate(this.body);
    }
  }
};
</script>

<style scoped>
</style>
